import { HorizontalContainer, Wrapper } from '@american-autonomy/ag-ui';

import CaptionText from 'components/text/CaptionText';

import { TEST_ID } from './constants';
import type { FunctionComponent, Props } from './types';

import styles from './styles.module.scss';

const StatusBadge: FunctionComponent<Props> = ({ className = '', testId = TEST_ID, text }) => (
    <HorizontalContainer className={`${className} ${styles.statusBadge}`} testId={testId}>
        <Wrapper className={styles.indicator} />

        <CaptionText className={styles.captionText} text={text} />
    </HorizontalContainer>
);

export default StatusBadge;
